import { UpgradeOverlay } from '@renderer/chat'
import { twMerge } from 'tailwind-merge'
import { SummaryMarkdown } from '@renderer/components/summary-markdown'

export { SummaryMarkdown } from '@renderer/components/summary-markdown'

const MOCK_SUMMARY = `## UI Elements

- A green dot/indicator that shows up when an input field is focused
- Potential for the dot to glow or expand when hovered
- Concerns about the clickable area of the indicator
- Discussion of visual transitions and animations

## Technical Implementation Challenges

- Tracking mouse proximity for hover effects
- Performance concerns, especially on Windows
- Challenges with transparent windows and click-through functionality
- Need to balance interactivity with performance

## Dictation Functionality

- Real-time streaming audio implementation
- Options for how dictated text is handled:
  - Automatic typing into input fields
  - Paste functionality when no input field is detected
  - Text selection after pasting for further actions

## Additional Features

- Grammar fixing capabilities for selected text
- Function key to start/stop dictation
- Text selection and editing options

## Next Steps

- Implementing a simple green dot indicator (estimated 20 minutes of work)
- Investigating mouse position tracking feasibility
- Adapting existing code for real-time audio streaming
- Target to have something functional by Monday`

/**
 * Pro upsell for the summary surface: blurred mock summary behind an upgrade CTA.
 * UpgradeOverlay only overlays for free (non-legacy) users, so gate call sites on `isFree`.
 */
export function SummaryUpgradeNotice({ context, markdownClassName }: { context: string; markdownClassName?: string }) {
  return (
    <UpgradeOverlay
      context={context}
      featureTitle="Meeting Summaries"
      message="Get the most out of your meeting notes with summaries calling out action items, important decisions and more."
      showImage={true}
      imageUrl="https://storage.googleapis.com/cdn.highlightai.com/media/product/payment/summary-upgrade-2.webp"
      className="h-auto"
    >
      <div className="max-h-[400px] overflow-hidden">
        <SummaryMarkdown
          size="sm"
          summary={MOCK_SUMMARY}
          isPending={false}
          className={twMerge('text-foreground-secondary', markdownClassName)}
        />
      </div>
    </UpgradeOverlay>
  )
}
